
export const CONFIRMED_GET_LEAD_NOTES = "CONFIRMED_GET_LEAD_NOTES";
export const CONFIRMED_CREATE_LEAD_NOTE_ACTION = "CONFIRMED_CREATE_LEAD_NOTE_ACTION";
